import { render, staticRenderFns } from "./BatteryNoData.vue?vue&type=template&id=251e22ca&"
import script from "./BatteryNoData.vue?vue&type=script&lang=js&"
export * from "./BatteryNoData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports